var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{style:({height: _vm.props.size + 'px', width: _vm.props.size + 'px'})})}
var staticRenderFns = []

export { render, staticRenderFns }